export default __webpack_public_path__ + "static/media/coinbase_icon.79e71308.png";